import { render, staticRenderFns } from "./weekly-quantities-tree-rows.vue?vue&type=template&id=844a6596&scoped=true"
import script from "./weekly-quantities-tree-rows.vue?vue&type=script&lang=js"
export * from "./weekly-quantities-tree-rows.vue?vue&type=script&lang=js"
import style0 from "./weekly-quantities-tree-rows.vue?vue&type=style&index=0&id=844a6596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844a6596",
  null
  
)

export default component.exports